<template>
  <span>
    <v-tooltip bottom>
    <template v-slot:activator="{ on }">
            <span v-on="on">
              <arb-btn-menu
                v-model="basic.actionList"
                btnType="widthIconBtn"
                :icon="'notes'"
                @click="clickActionEventHandler"
              >
              </arb-btn-menu>
            </span>
    </template>
    <span>Edit Profiles</span>
  </v-tooltip>
  <v-dialog v-model="dialog.profileSectionDialog.display" persistent :max-width="'950px'">
    <old-profile-section-dialog
      v-if="dialog.profileSectionDialog.display"
      :loan="loan"
      :slaveLoanId="slaveLoanId"
      :layoutSetting="dialog.profileSectionDialog.layoutSetting"
      :dataSource="dataSource"
      :extension="extension"
      :setting="dialog.profileSectionDialog"
      :typeNote="true"
    ></old-profile-section-dialog>
  </v-dialog>
  </span>
</template>

<script>
import OldProfileSectionDialog from '@/components/panda/common/dialog/OldProfileSectionDialog'
import { SystemEnum } from '@/assets/js'
import { BASIC_DETAIL_LAYOUT_SETTING } from '@/setting/layout/basic/detail'
import { DataType, Tool } from '@/util/index'
import { OriginationApi, RuntimeApi } from '@/api/pandaria'
import { _ } from 'vue-underscore'
const tool = new Tool()
export default {
  name: 'edit-profile-dialog',
  components: {
    OldProfileSectionDialog
  },
  props: {
    loan: Object,
    slaveLoanId: Number
  },
  data () {
    return {
      basic: {
        actionList: [
          {
            text: 'Personal',
            value: SystemEnum.SECTION_FEATURE.PERSONAL
          },
          {
            text: 'Employment',
            value: SystemEnum.SECTION_FEATURE.EMPLOYMENT
          },
          {
            text: 'Bank',
            value: SystemEnum.SECTION_FEATURE.BANK
          }
        ]
      },
      dialog: {
        profileSectionDialog: {
          action: 'EDIT',
          display: false,
          layoutSetting: []
        }
      },
      dataType: DataType,
      systemEnum: SystemEnum,
      dataSource: {
        sectionData: {},
        answerData: [],
        questionTemplateData: []
      },
      extension: {
        questionOptionData: {},
        questionAnswerData: {}
      },
      questionTemplate: []
    }
  },
  computed: {
    loanId () {
      if (tool.isNotEmpty(this.store.getters.getPPSLatestAppId) && this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        return this.store.getters.getPPSLatestAppId
      } else if (this.loan.loanType === DataType.LoanTypeEnum.INSTALLMENT_LOAN.value) {
        return this.loan.id
      } else {
        return null
      }
    },
    parentLoanId () {
      return this.loan.id
    }
  },
  watch: {},
  methods: {
    clickActionEventHandler (feature) {
      switch (feature) {
        case SystemEnum.SECTION_FEATURE.PERSONAL:
          this.dialog.profileSectionDialog.layoutSetting = BASIC_DETAIL_LAYOUT_SETTING.PERSONAL
          break
        case SystemEnum.SECTION_FEATURE.EMPLOYMENT:
          this.dialog.profileSectionDialog.layoutSetting = BASIC_DETAIL_LAYOUT_SETTING.EMPLOYMENT
          break
        case SystemEnum.SECTION_FEATURE.BANK:
          this.dialog.profileSectionDialog.layoutSetting = BASIC_DETAIL_LAYOUT_SETTING.BANK
          break
        default:
          break
      }
      this.getLoanFeatureData(feature)
    },
    async getLoanFeatureData (feature) {
      const loanId = this.parentLoanId
      const $this = this
      if (SystemEnum.SECTION_FEATURE.BANK === feature) {
        for (const metadata of this.dialog.profileSectionDialog.layoutSetting.metadata) {
          switch (metadata.name) {
            case 'questionType':
              await RuntimeApi.fetchQuestionTemplateByGroupId(metadata.value, this.listQuestionTemplateCallback, null, true)
              await OriginationApi.listLoanQuestionData(loanId, this.getLoanQuestionDataCallback, null, true)
              break
            default:
              break
          }
        }
      }
      await OriginationApi.getLoanFeatureData(loanId, 'get', feature, function (sectionData) {
        $this.dataSource.sectionData = sectionData
      }, null, true)
      this.dialog.profileSectionDialog.display = true
    },
    listQuestionTemplateCallback (result) {
      this.questionTemplate = result
      this.storeQuestionTemplate()
    },
    getLoanQuestionDataCallback (result) {
      this.storeAnswerData(result)
    },
    storeQuestionTemplate () {
      let questionTemplateData = JSON.parse(JSON.stringify(this.questionTemplate))
      if (tool.isEmpty(questionTemplateData)) {
        questionTemplateData = []
      }

      const data = this.getFullName(this.store.getters.getLoan)
      for (const item of questionTemplateData) {
        if (item.id === 4) {
          item.question = _.template(item.question)({ data: data })
        }
      }
      this.dataSource.questionTemplateData = questionTemplateData

      const questionOptionCache = {}
      for (const item of this.dataSource.questionTemplateData) {
        const optionArray = (item.options).toJson()
        const optionCache = {}
        for (const optionItem of optionArray) {
          optionCache[optionItem.value] = optionItem.text
        }
        questionOptionCache[item.id] = optionCache
      }
      this.extension.questionOptionData = questionOptionCache
    },
    storeAnswerData (answerData) {
      if (tool.isEmpty(answerData)) {
        answerData = []
      }
      answerData = answerData.filter(item => item.question !== 2)
      this.dataSource.answerData = answerData
      const questionAnswerData = {}

      if (answerData.length > 0) {
        for (const item of answerData) {
          questionAnswerData[item.question] = {
            value: item.answer,
            text: this.extension.questionOptionData[item.question][item.answer]
          }
        }
      } else {
        const questions = Object.keys(this.extension.questionOptionData)
        for (const question of questions) {
          questionAnswerData[question] = null
        }
      }

      this.extension.questionAnswerData = questionAnswerData
    },
    getFullName (data) {
      return {
        fullName: tool.getFullName(data)
      }
    }
  }
}
</script>
